<template>
  <v-container class="pa-4 pa-sm-8" fluid>
    <v-row class="mt-3 mt-sm-0">
      <h2 class="dark--text text-h5 font-weight-bold ms-4">Plan Suggestions</h2>
      <v-spacer></v-spacer>
      <v-layout justify-end class="mb-5 pe-3">
        <v-btn @click="onAddSuggestion" v-if="hasRole(AdminUserPermissions.DIETITIAN_PLAN_SUGGESTION)" class="text-capitalize font-weight-bold" color="primary">
          + Add Suggestion
        </v-btn>
      </v-layout>
    </v-row>

    <v-data-table :headers="headers" :items="itemsWithSno" class="mt-2 elevation-1" :loading="loading" :mobile-breakpoint="0">
      <template v-slot:item.actions="{ item }">
        <v-btn small color="error" @click="deleteSuggestion(item.planId._id)">
          Delete
        </v-btn>
      </template>
    </v-data-table>

    <!-- Add Suggestion Dialog -->
    <v-dialog v-model="dialog" max-width="600px">
      <v-card>
        <v-card-title>Add Plan Suggestion</v-card-title>
        <v-card-text>
          <v-form ref="form" v-model="valid">
            <v-select v-model="selectedPlan" :items="plans" item-text="titleEn" item-value="_id" label="Select Plan" :rules="[v => !!v || 'Plan is required']" required></v-select>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closeDialog">Cancel</v-btn>
          <v-btn color="primary" class="light--text" @click="createSuggestion" :loading="btnLoading" :disabled="!valid">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar" :color="snackColor" timeout="3000">
      {{ snackText }}
    </v-snackbar>
  </v-container>
</template>

<script>
import { isDietitian } from "../../../user/methods/helper";

export default {
  data() {
    return {
      suggestions: [],

      plans: [],
      dialog: false,
      valid: false,
      btnLoading: false,
      selectedPlan: null,
      loading: true,
      snackbar: false,
      snackColor: "success",
      snackText: "",
      headers: [
        { text: "S.No", value: "slNo" },
        { text: "Plan Name", value: "planName" },
        { text: "Active", value: "active" },
        { text: "Actions", value: "actions", sortable: false },
      ],
    };
  },
  apollo: {
    getAllPackages() {
      return {
        query: require("@/menu-packages/api/getAllPackages.graphql"),
        result({ data }) {
          this.plans = data.getAllPackages.packages.filter(x => x.active);
        },
      };
    },
    getDietitianSuggestedPlans() {
      return {
        query: require("../api/getDietitianSuggestedPlans.graphql"),
        result({ data, loading }) {
          this.loading = loading;
          this.suggestions = data.getDietitianSuggestedPlans || [];
        },
      };
    },
  },
  methods: {
    onAddSuggestion() {
      this.dialog = true;
    },

    createSuggestion() {
      if (this.$refs.form.validate()) {
        this.btnLoading = true;
        this.$apollo
          .mutate({
            mutation: require("../api/createPlanSuggestion.graphql"),
            variables: {
              planId: this.selectedPlan,
            },
          })
          .then(() => {
            this.snackColor = "success";
            this.snackText = "Plan suggestion added successfully";
            this.snackbar = true;
            this.closeDialog();
            this.$apollo.queries.getDietitianSuggestedPlans.refetch();
          })
          .catch(error => {
            this.snackColor = "error";
            this.snackText = error.graphQLErrors?.[0]?.message || "Error adding suggestion";
            this.snackbar = true;
          })
          .finally(() => {
            this.btnLoading = false;
          });
      }
    },

    deleteSuggestion(planId) {
      this.$apollo
        .mutate({
          mutation: require("../api/removePlanSuggestion.graphql"),
          variables: {
            planId: planId,
          },
        })
        .then(() => {
          this.snackColor = "success";
          this.snackText = "Plan suggestion removed successfully";
          this.snackbar = true;
          this.$apollo.queries.getDietitianSuggestedPlans.refetch();
        })
        .catch(error => {
          this.snackColor = "error";
          this.snackText = error.graphQLErrors?.[0]?.message || "Error removing suggestion";
          this.snackbar = true;
        });
    },

    closeDialog() {
      this.dialog = false;
      this.$refs.form.reset();
      this.selectedPlan = null;
    },
  },
  computed: {
    itemsWithSno() {
      return this.suggestions.map((item, index) => ({
        ...item,
        slNo: index + 1,
        planName: item.titleEn || "N/A",
      }));
    },
  },
  created() {
    if (!isDietitian()) {
      this.$router.push({
        name: "Error404",
      });
    }
    if (!this.hasRole(this.AdminUserPermissions.DIETITIAN_PLAN_SUGGESTION)) {
      this.$router.push({
        name: "Error404",
      });
    }
  },
};
</script>

<style>
.inputPhone input[type=""] {
  -moz-appearance: textfield;
}

.inputPhone input::-webkit-outer-spin-button,
.inputPhone input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

.theme--light.v-list-item--active:hover::before,
.theme--light.v-list-item--active::before {
  opacity: 0.2 !important;
}
</style>
